// Chart card shell: title, subtitle, and the table-view twin every chart must have.
//
// The table view is not optional decoration — three light-mode categorical slots sit
// below 3:1 contrast on the surface, which triggers the palette's relief rule
// (visible labels OR a table view). It is also the keyboard/screen-reader path to
// every value a tooltip shows.
export default function ChartCard({ title, subtitle, children, table, showTable, onToggleTable }) {
  return (
    <section className="card">
      <header className="card__head">
        <div>
          <h2 className="card__title">{title}</h2>
          {subtitle && <p className="card__subtitle">{subtitle}</p>}
        </div>
        {table && (
          <button
            type="button"
            className="ghost-btn"
            aria-pressed={showTable}
            onClick={onToggleTable}
          >
            {showTable ? 'Hide table' : 'Table'}
          </button>
        )}
      </header>
      {/* The chart NEVER yields its space — toggling the table appends it below at
          full size, so the graph is not squeezed into a sliver to make room. */}
      {children}
      {showTable && table && <div className="card__table card__table--below">{table}</div>}
    </section>
  );
}
